import { jsx as ___EmotionJSX } from "@emotion/core";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { css } from "./Theme";
import Flex from "./Flex";
import Input from "./Input";
import Text from "./Text";

const RadioButton = props => {
  const hoverStyles = css({
    "&:hover": {
      cursor: "pointer"
    }
  });
  const containerStyles = css({ ...hoverStyles
  });
  const styles = css({ ...hoverStyles,
    width: "auto",
    display: "block"
  });
  return ___EmotionJSX(Flex, _extends({}, props, {
    css: hoverStyles,
    onClick: props.onChange
  }), ___EmotionJSX(Input, {
    type: "radio",
    name: props.name,
    onChange: props.onChange,
    checked: props.checked,
    css: styles
  }), ___EmotionJSX(Text, {
    css: css({
      pl: 2
    })
  }, props.children));
};

export default RadioButton;